import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, ScrollText, ArrowRight } from "lucide-react";
import { VerdictPanel } from "@/components/VerdictPanel";
import { api } from "@/lib/api";

export default function Shared() {
  const { shareId } = useParams();
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/shared/${shareId}`)
      .then(({ data }) => setResult(data))
      .catch((e) => setError(e.response?.data?.detail || "This link is no longer available."));
  }, [shareId]);

  return (
    <div className="grain min-h-screen">
      <header className="border-b border-stone-200 bg-[#fafaf9]/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[900px] items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3" data-testid="shared-logo">
            <span className="flex h-9 w-9 items-center justify-center bg-[#0f172a] text-white"><ScrollText className="h-4 w-4" /></span>
            <span className="font-display text-lg font-bold tracking-tight">Ledger<span className="text-slate-500">Check</span></span>
          </Link>
          <Link to="/analyze" data-testid="shared-cta"
            className="group inline-flex items-center gap-2 bg-[#0f172a] px-5 py-2.5 text-xs font-medium text-white transition-colors duration-150 hover:bg-stone-800">
            Check your own entry
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-150 group-hover:translate-x-1" />
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-[900px] px-6 py-14">
        <p className="overline text-slate-500">Shared review · read only</p>
        <h1 className="font-display mt-4 text-4xl font-bold tracking-tight sm:text-5xl">Journal entry verdict</h1>

        {error ? (
          <p className="mt-12 text-sm text-slate-500" data-testid="shared-error">{error}</p>
        ) : !result ? (
          <div className="mt-16 flex items-center gap-2 text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Loading…</div>
        ) : (
          <div className="mt-10" data-testid="shared-verdict">
            <div className="mb-6 border border-stone-200 bg-white p-6">
              <p className="overline mb-3 text-slate-500">Entry reviewed</p>
              <pre className="whitespace-pre-wrap font-mono-data text-sm text-slate-700">{result.input_summary}</pre>
              {result.narration && <p className="mt-3 text-sm italic text-slate-500">{result.narration}</p>}
            </div>
            <VerdictPanel result={result} shareable={false} />
          </div>
        )}
      </main>
    </div>
  );
}
